export default "__VITE_ASSET__CLOB8P99__"